export function getParamFromQua(qua2, key) {
  if (!qua2) {
    return '';
  }
  let arr = qua2.split(`${key}=`);
  if (!arr[1]) {
    return '';
  }
  arr = arr[1].split('&');
  return arr[0];
};
